// Escolha da ABA da planilha, no lado do app.
//
// Nasceu de uma falha medida em 28/08/2026: a planilha real de um cliente
// (3,7 MB, 28 abas) derrubava a edge function com "Memory limit exceeded",
// porque ela lia o arquivo INTEIRO -- as 28 abas -- para usar so a primeira. E,
// pior, "a primeira" era a aba errada: nesse arquivo a lista de produtos esta na
// aba PR00, e a primeira e um simulador de impostos.
//
// A edge agora le so os NOMES das abas primeiro. Quando ha mais de uma e a
// pessoa ainda nao escolheu, ela devolve 200 com `precisa_escolher_aba` e para
// ali -- sem parsear nada. Este modulo e a metade do app: le esse sinal e monta
// o corpo do reenvio.

export interface EscolhaDeAba {
  abas: string[]
  // Caminho no storage devolvido pela PRIMEIRA chamada. Reenviado para a edge
  // nao arquivar a mesma planilha duas vezes.
  arquivadoEm: string
}

export interface CorpoBase {
  formato: string
  nome_arquivo: string
  conteudo_base64: string
}

export interface CorpoImportarArquivo extends CorpoBase {
  aba?: string
  ja_arquivado_em?: string
  // ⚠⚠ O ANUNCIO DE CAPACIDADE, e ele existe por compatibilidade: a edge e UMA
  // SO e atende ao mesmo tempo este app e o que ja esta publicado. O publicado
  // faz `setColunas(data.colunas)` sem checar nada -- se receber
  // `precisa_escolher_aba`, `colunas` chega `undefined` e a tela quebra na mao
  // de quem esta vendendo na rua. Quem nao anuncia continua recebendo a
  // primeira aba, como sempre; o conserto da MEMORIA vale para os dois.
  suporta_escolha_de_aba: true
}

// A resposta da edge esta pedindo a escolha da aba?
//
// Exige o sinal E a lista: um sinal sem lista mandaria a tela para uma etapa de
// escolha VAZIA, sem nenhuma saida para a pessoa.
export function pedeEscolhaDeAba(data: unknown): EscolhaDeAba | null {
  if (!data || typeof data !== 'object') return null
  const corpo = data as { precisa_escolher_aba?: unknown; abas?: unknown; arquivado_em?: unknown }
  if (corpo.precisa_escolher_aba !== true) return null
  if (!Array.isArray(corpo.abas) || corpo.abas.length === 0) return null
  return {
    abas: corpo.abas.map(String),
    arquivadoEm: typeof corpo.arquivado_em === 'string' ? corpo.arquivado_em : '',
  }
}

// Monta o corpo do POST. Os dois campos novos so entram quando ha valor: mandar
// `aba: ''` faria a edge procurar uma aba de nome vazio e responder 422.
//
// ⚠ O nome da aba vai CRU, sem aparar: nome de aba do Excel pode ter espaco no
// fim, e aparar transformaria "Planilha 3 " numa aba que nao existe.
export function corpoImportarArquivo(
  base: CorpoBase,
  escolha?: { aba?: string; jaArquivadoEm?: string },
): CorpoImportarArquivo {
  const aba = escolha?.aba ?? ''
  const arquivado = escolha?.jaArquivadoEm ?? ''
  return {
    ...base,
    suporta_escolha_de_aba: true,
    ...(aba.trim() === '' ? {} : { aba }),
    ...(arquivado.trim() === '' ? {} : { ja_arquivado_em: arquivado }),
  }
}
